module.exports = __webpack_public_path__ + "static/media/filters.3446a4a2.svg";